import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Per-section collapse state for the sidebar, persisted across reloads.
 * Sections default to open except those in DEFAULT_COLLAPSED. */
const DEFAULT_COLLAPSED = new Set<string>(['My Space']);

interface NavCollapseState {
  /** Explicit user overrides, keyed by section heading. */
  openByHeading: Record<string, boolean>;
  setOpen: (heading: string, open: boolean) => void;
  /** Whole-sidebar collapse on desktop (Plane-style panel toggle). */
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

export const useNavCollapse = create<NavCollapseState>()(
  persist(
    (set) => ({
      openByHeading: {},
      setOpen: (heading, open) =>
        set((s) => ({ openByHeading: { ...s.openByHeading, [heading]: open } })),
      sidebarCollapsed: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
    }),
    { name: 'nav.sections:collapse' },
  ),
);

/** Effective open state: a saved override wins, else the section default. */
export function sectionDefaultOpen(heading: string): boolean {
  return !DEFAULT_COLLAPSED.has(heading);
}
